import { cloneDeep, partition, unset, values } from 'lodash'

import { PRINTING_ENABLED } from '../constants'
import { DEFAULT_PRINTERS } from '../utils/printing'

export const getPrinterRequestStatus = (state) => {
  return state.printer?.requestStatus
}

export const getPrinters = (state) => {
  const printers = cloneDeep(state?.printer?.byId)
  let result = []

  // needs to remove 'local' printer in case a local printer was previously saved in redux on the device
  unset(printers, 'local')

  const [receiptPrinters, nonReceiptPrinters] = partition(printers, 'receiptPrinter')
  result = [...result, ...receiptPrinters, ...nonReceiptPrinters]

  return result
}

export const getNetworkPrinters = (state) => {
  const printers = getPrinters(state)
  return printers?.filter((printer) => printer?.receiptPrinter)
}

export const getPrinter = (state, printerId) => {
  return state.printer.byId?.[printerId]
}

export const calculatePrintingEnabled = (printerId) => {
  return PRINTING_ENABLED || (!!printerId && printerId !== 'none')
}

export const getUsbPrintingEnabled = (state) => {
  return state.printer.networkPrinterUuid === 'usb'
}

export const getPrintingEnabled = (state) => {
  return calculatePrintingEnabled(state.printer.networkPrinterUuid)
}

export const getNetworkPrinter = (state) => {
  return state.printer.networkPrinterUuid
}

export const getCloudPrintingEnabled = (state) => {
  return !values(DEFAULT_PRINTERS)
    .map((printer) => printer.uuid)
    .includes(state.printer.networkPrinterUuid)
}
